import type { Period } from '../store/store';
import { buildPeriodSelect } from '../util';
import { formatPeriod, formatPeriodDisplayName } from './periodUtils';

const getPeriodDescription = (period: Period) => {
  // 'all' lives in project-scoped extras (see ProjectPeriodFilter), not in the standard set.
  if (period.periodSlug === 'all') return 'Alla år';

  const dateObject = formatPeriod(period, buildPeriodSelect());
  if (!dateObject) return '';

  if (dateObject.periodSlug === 'custom') {
    return formatPeriodDisplayName(dateObject);
  }

  return dateObject.title;
};

export { getPeriodDescription };
